import { Divider as NativeDivider } from '@mantine/core';

export const Divider = (props: { size: string }) => {
	return <NativeDivider color="#E4E7FF" {...props} />;
};
